import React, { useEffect, useState } from "react";

import {
    getClientClaimById,
    updateClientClaim
} from "../../api/ClientClaimApi";

import {
    getAllClients
} from "../../api/ClientApi";
import CustomSelect from "../shared/CustomSelect";
import { toast } from "../shared/Toast";

const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";
    if (typeof dateStr === "string" && dateStr.includes("T")) {
        return dateStr.split("T")[0];
    }
    return dateStr;
};

const EditClientClaimModal = ({
    id,
    close,
    refresh
}) => {

    const [loading, setLoading] = useState(false);

    const [clients, setClients] = useState([]);

    const [form, setForm] = useState({

        clientId: "",

        fromDate: "",

        toDate: "",

        totalTrips: "",

        totalAmount: "",

        deduction: "",

        finalClaimAmount: 0,

        remarks: "",

        status: "Draft"

    });

    const fetchClients = async () => {

        try {

            const response = await getAllClients();
            const clientList = response?.clients || response?.data || (Array.isArray(response) ? response : []);

            setClients(
                Array.isArray(clientList) ? clientList : []
            );

        }

        catch (error) {

            console.log(error);
            setClients([]);

        }

    };

    const fetchClaim = async () => {

        try {

            const response = await getClientClaimById(id);

            const claim = response?.data || response;

            if (claim) {
                setForm({

                    clientId: claim.clientId || "",

                    fromDate: formatDateForInput(claim.fromDate),

                    toDate: formatDateForInput(claim.toDate),

                    totalTrips: claim.totalTrips || "",

                    totalAmount: claim.totalAmount || "",

                    deduction: claim.deduction || 0,

                    finalClaimAmount: claim.finalClaimAmount || 0,

                    remarks: claim.remarks || "",

                    status: claim.status || "Draft"

                });
            }

        }

        catch (error) {

            console.log(error);

            toast.error("Unable to load claim");

        }

    };

    useEffect(() => {

        fetchClients();

        fetchClaim();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        const amount = Number(form.totalAmount || 0);

        const deduction = Number(form.deduction || 0);

        setForm(prev => ({

            ...prev,

            finalClaimAmount: Math.max(amount - deduction, 0)

        }));

    }, [

        form.totalAmount,

        form.deduction

    ]);

    const handleChange = (e) => {

        setForm({

            ...form,

            [e.target.name]: e.target.value

        });

    };
    const handleSubmit = async (e) => {

        e.preventDefault();

        if (form.toDate < form.fromDate) {

            toast.warning(
                "To Date cannot be before From Date"
            );

            return;

        }
        try {

            setLoading(true);

            await updateClientClaim(id, {

                clientId: form.clientId,

                fromDate: form.fromDate,

                toDate: form.toDate,

                totalTrips: Number(form.totalTrips),

                totalAmount: Number(form.totalAmount),

                deduction: Number(form.deduction),
                finalClaimAmount: Number(form.finalClaimAmount),

                remarks: form.remarks,

                status: form.status

            });

            toast.success("Client Claim updated successfully");

            refresh();

            close();

        }

        catch (error) {

            console.log(error);

            toast.error("Unable to update Client Claim");

        }

        finally {

            setLoading(false);

        }

    };

    return (

        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000
            }}
        >

            <form

                onSubmit={handleSubmit}

                style={{
                    width: 550,
                    background: "#fff",
                    borderRadius: 10,
                    padding: 30,
                    maxHeight: "90vh",
                    overflowY: "auto"
                }}

            >

                <h2
                    style={{
                        marginBottom: 20
                    }}
                >
                    Edit Client Claim
                </h2>

                <label style={{ fontSize: '13px', fontWeight: 500, color: '#374151', display: 'block', marginBottom: '6px' }}>Client *</label>

                <div style={{ marginBottom: '15px' }}>
                    <CustomSelect
                        searchable
                        options={Array.isArray(clients) ? clients.map(client => ({ value: client.id, label: client.clientName })) : []}
                        value={form.clientId}
                        onChange={(val) => handleChange({ target: { name: 'clientId', value: val } })}
                        placeholder="Choose Client"
                    />
                </div>

                <label>From Date</label>

                <input

                    type="date"

                    name="fromDate"

                    value={form.fromDate}

                    onChange={handleChange}

                    style={input}

                    required

                />

                <label>To Date</label>

                <input

                    type="date"

                    name="toDate"

                    value={form.toDate}

                    onChange={handleChange}

                    style={input}

                    required

                />

                <label>Total Trips</label>

                <input

                    type="number"

                    name="totalTrips"

                    value={form.totalTrips}

                    onChange={handleChange}

                    style={input}

                    required

                />

                <label>Total Amount</label>

                <input

                    type="number"

                    name="totalAmount"

                    value={form.totalAmount}

                    onChange={handleChange}

                    style={input}

                    required

                />

                <label>Deduction</label>

                <input

                    type="number"

                    name="deduction"

                    value={form.deduction}

                    onChange={handleChange}

                    style={input}

                />

                <label>Final Claim Amount</label>

                <input

                    value={`₹ ${form.finalClaimAmount}`}

                    readOnly

                    style={{
                        ...input,
                        background: "#f5f5f5",
                        fontWeight: 600
                    }}

                />

                <label style={{ fontSize: '13px', fontWeight: 500, color: '#374151', display: 'block', marginBottom: '6px' }}>Status</label>

                <div style={{ marginBottom: '15px' }}>
                    <CustomSelect
                        options={["Draft", "Submitted", "Approved", "Paid"]}
                        value={form.status}
                        onChange={(val) => handleChange({ target: { name: 'status', value: val } })}
                        placeholder="Select Status"
                    />
                </div>

                <label>Remarks</label>

                <textarea

                    rows={4}

                    name="remarks"

                    value={form.remarks}

                    onChange={handleChange}

                    style={{
                        ...input,
                        resize: "none"
                    }}

                />

                <div

                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 15,
                        marginTop: 20
                    }}

                >

                    <button

                        type="button"

                        onClick={close}

                        style={cancelBtn}

                    >

                        Cancel

                    </button>

                    <button

                        type="submit"

                        disabled={loading}

                        style={saveBtn}

                    >

                        {

                            loading

                                ? "Updating..."

                                : "Update"

                        }

                    </button>

                </div>

            </form>

        </div>

    );

};

const input = {

    width: "100%",

    padding: "10px 14px",

    marginTop: 8,

    marginBottom: 15,

    border: "1px solid #E5E7EB",

    borderRadius: 8,

    fontSize: "14px",

    outline: "none",

    boxSizing: "border-box"

};

const saveBtn = {

    background: "#20B967",

    color: "#fff",

    border: "none",

    padding: "10px 25px",

    borderRadius: 6,

    cursor: "pointer"

};

const cancelBtn = {

    background: "#ddd",

    border: "none",

    padding: "10px 25px",

    borderRadius: 6,

    cursor: "pointer"

};

export default EditClientClaimModal;